// src/utils/ScrollToTopApp.jsx

import { useEffect } from 'react';

export default function ScrollToTopApp({ dependency }) {
  useEffect(() => {
    const el = document.querySelector('.app-content');
    if (el) el.scrollTo({ top: 0, behavior: 'auto' });
  }, [dependency]);

  return null;
}